<div class="modal-header">
    <h4 class="modal-title">Import Lines From Invoice</h4>
</div>
<div class="modal-body p-0">
    <div class="m-2">
        <dx-data-grid
            #linesGrid
            keyExpr="id"
            class="lines-grid"
            [dataSource]="invoiceLines"
            height="500"
            [columnAutoWidth]="false"
            (onExporting)="onExporting($event)"
            [showBorders]="true"
        >
            <dxi-column dataField="invoice.invoiceNumber" caption="Invoice #" width="90"></dxi-column>
            <dxi-column dataField="invoice.invoiceDate" caption="Invoice Date" width="100" dataType="date"></dxi-column>
            <dxi-column dataField="partNumber" caption="Part #" width="200" cellTemplate="linkTemplate"></dxi-column>
            <dxi-column dataField="description" width="250"></dxi-column>
            <dxi-column dataField="quantity" caption="Qty" width="65"></dxi-column>
            <dxi-column dataField="price" caption="Price" width="100" alignment="right" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="orderLineDetail.vIN" caption="VIN #" width="165"></dxi-column>

            <div *dxTemplate="let cell of 'linkTemplate'">
                <div
                    class="parent-part-number"
                    *ngIf="
                        cell.data?.orderLineDetail?.orderLine?.partId &&
                        !cell.data?.orderLineDetail?.orderLine?.parentLineId &&
                        !cell.data?.orderLineDetail?.orderLine?.isReplacement
                    "
                >
                    {{ cell.text }}
                </div>
                <div class="replacement-part-number" *ngIf="cell.data?.orderLineDetail?.orderLine?.isReplacement">{{ cell.text }}</div>
                <div class="option-part-number" *ngIf="cell.data?.orderLineDetail?.orderLine?.parentLineId">{{ cell.text }}</div>
                <div class="fee-part-number" *ngIf="cell.data?.feeTypeId">{{ cell.text }}</div>
                <div
                    class="misc-part-number"
                    *ngIf="!cell.data?.feeTypeId && !cell.data?.orderLineDetail?.orderLine?.partId && !cell.data?.orderLineDetail?.orderLine?.isReplacement"
                >
                    {{ cell.text }}
                </div>
            </div>

            <dxo-export [enabled]="true"></dxo-export>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-selection mode="multiple"></dxo-selection>
        </dx-data-grid>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-primary" (click)="add()" [disabled]="!hasSelection()">Add Selected</button>
    <button class="btn btn-light" (click)="close()">Cancel</button>
</div>
